import React from "react";
import { Phone, Clock, Package } from "lucide-react";
import { EntregadorNaFila } from "../types";

interface FilaEntregadoresProps {
  entregadores: EntregadorNaFila[];
  onChamarEntregador?: (entregadorId: number, nome: string) => void;
}

const FilaEntregadores: React.FC<FilaEntregadoresProps> = ({
  entregadores,
  onChamarEntregador,
}) => {
  return (
    <div className="rounded-lg bg-white p-6 shadow">
      <div className="mb-6 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-warning-light">
            <Clock size={20} className="text-warning" />
          </div>
          <div>
            <h3 className="text-xl font-bold text-neutral-900">
              Fila de Entregadores
            </h3>
            <p className="text-sm text-neutral-500">
              {entregadores.length} entregador
              {entregadores.length !== 1 ? "es" : ""} aguardando
            </p>
          </div>
        </div>
      </div>

      {entregadores.length === 0 ? (
        <div className="rounded-lg border-2 border-dashed border-neutral-200 bg-neutral-50 p-12 text-center">
          <Clock size={48} className="mx-auto mb-4 text-neutral-400" />
          <p className="text-lg font-medium text-neutral-500">
            Nenhum entregador na fila
          </p>
          <p className="mt-1 text-sm text-neutral-400">
            Os entregadores aparecerão aqui quando iniciarem o dia
          </p>
        </div>
      ) : (
        <div className="space-y-3">
          {entregadores.map((entregador, index) => (
            <div
              key={entregador.id}
              className={`group flex items-center justify-between rounded-lg border-2 p-4 transition-all ${
                index === 0
                  ? "border-primary bg-primary/10 shadow-md"
                  : "border-neutral-200 bg-white hover:border-neutral-300 hover:shadow-sm"
              }`}
            >
              <div className="flex items-center gap-4">
                <div
                  className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-full text-lg font-bold ${
                    index === 0
                      ? "bg-primary text-white shadow-lg"
                      : "bg-neutral-100 text-neutral-600"
                  }`}
                >
                  {entregador.posicao}
                </div>
                <div>
                  <h4
                    className={`font-semibold ${
                      index === 0 ? "text-primary" : "text-neutral-900"
                    }`}
                  >
                    {entregador.nome} {entregador.sobrenome}
                  </h4>
                  <div className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-0.5">
                    {index === 0 && (
                      <p className="text-xs font-medium text-primary">
                        Próximo a ser chamado
                      </p>
                    )}
                    <span className="flex items-center gap-1 text-xs text-neutral-500">
                      <Package size={12} />
                      {entregador.quantidadeEntregasFinalizadas}{" "}
                      {entregador.quantidadeEntregasFinalizadas === 1
                        ? "entrega finalizada"
                        : "entregas finalizadas"}
                    </span>
                  </div>
                </div>
              </div>
              {onChamarEntregador && (
                <button
                  onClick={() =>
                    onChamarEntregador(entregador.entregadorId, entregador.nome)
                  }
                  className={`flex h-10 w-10 items-center justify-center rounded-lg transition-all ${
                    index === 0
                      ? "bg-primary text-white hover:scale-110 hover:bg-primary-dark"
                      : "bg-neutral-100 text-neutral-600 hover:bg-primary hover:text-white"
                  }`}
                  aria-label={`Chamar ${entregador.nome}`}
                >
                  <Phone size={18} />
                </button>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FilaEntregadores;
